import { createConfigParametersRepository } from './configParametersRepository';
import type { ConfigRepositoryParameters } from './configParametersRepository/types';
import { initializeDatalayer } from './third-party-tracking/tag-commander/datalayer';

// ─── HTML Events ──────────────────────────────────────────────────────────────

export {
  createDataMeshTrackingClient,
  getPageRenderId, // WARNING: use only in frontend-core, frontend-html5 & frontend-home
  init,
  setBookingId,
  setSearchId,
  trackClick,
  trackClickEvent,
  trackComponentDisplayed,
  trackDOMComponentDisplayed,
  trackPageLoaded,
} from './html-events';

export type {
  ClickHtmlDatameshEvent,
  ComponentDisplayHtmlDatameshEvent,
  CreateDataMeshTrackingClientArgs,
  DataMeshTracker,
  DataMeshTrackingClient,
  MicroFrontEndConfig,
  PageLoadedHtmlDatameshEvent,
  PageLoadedTracker,
} from './html-events/types';

// ─── Third Party Tracking ─────────────────────────────────────────────────────

export {
  FULLSTORY_EXCLUDE_CLASS,
  FULLSTORY_MASK_CLASS,
} from './third-party-tracking/fullstory';

export { thirdPartyTracking } from './third-party-tracking';

// Custom Dimensions
export type {
  /** @deprecated use CustomParams */
  CustomDimensions,
  CustomDimensionsRepository,
  SetCustomDimensionOrParam,
} from './third-party-tracking/types';

// Google Analytics
export type {
  /** @deprecated use CustomParams */
  CustomDimensionsOrParams,
  CustomParams,
} from './third-party-tracking/google-analytics/ga4Types';

// E-Commerce
export type { ECommerce4Transaction } from './third-party-tracking/eCommerceTrackingClient/types';

// Third Party Tracking Agent
export type {
  ThirdPartyTrackingAgent,
  ThirdPartyTrackingAgentArgs,
  TrackEventArguments,
  TrackPage,
  TrackPageOptions,
} from './third-party-tracking/thirdPartyTrackingAgent/types';

// Tag Commander / Datalayer
export type {
  Datalayer,
  DatalayerEventPayload,
  DatalayerTrackingClient,
  TMSFetchOptions,
  TrackTMSPageDatalayer,
} from './third-party-tracking/tag-commander/types';

// Tracking Params
export type { TrackingParamsRepository } from './third-party-tracking/trackingParamsRepository/types';

// ─── Configuration ────────────────────────────────────────────────────────────

export type { ConfigRepositoryParameters } from './configParametersRepository/types';

export const initTrackingAgent = (configParams: ConfigRepositoryParameters) => {
  const { init } = createConfigParametersRepository();
  init(configParams);
  initializeDatalayer();
};
